import { useEffect } from 'react';

import { initGlobalStore } from '@dmp/stores/globalStore';
import { subscribeToCrossTabLogout } from '@dmp/utils/auth';

export const useInitGlobalStore = () => {
  useEffect(() => {
    initGlobalStore();
    return subscribeToCrossTabLogout();
  }, []);
};
